import { eEstadoMaestro } from "../common/enumModel";
import { IProyectoModel } from "../interfaces/proyectos/IProyectoModel";

export class ProyectoModel implements IProyectoModel {
    
    idProyecto : number;
    nombre : string;
    idEstado: eEstadoMaestro;
    estado: string;
    
    constructor(){
        this.idProyecto = 0;
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.estado = '';
    }
}